export default __webpack_public_path__ + "static/media/bra-arte-8.cd003d04.webp";